var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import TimeInput from '../time-input';
import { Styled } from './style';
var TimeRange = /** @class */ (function (_super) {
    __extends(TimeRange, _super);
    function TimeRange(props) {
        var _this = _super.call(this, props) || this;
        _this.getStartCursor = function (currentPos) {
            if (currentPos >= 5) {
                if (_this.endRef && _this.endRef.current) {
                    _this.endRef.current.focus();
                    _this.endRef.current.selectionStart = 0;
                    _this.endRef.current.selectionEnd = 0;
                }
            }
        };
        _this.getEndCursor = function (currentPos) {
            if (currentPos === 0) {
                if (_this.startRef && _this.startRef.current) {
                    _this.startRef.current.focus();
                    _this.startRef.current.selectionStart = 5;
                    _this.startRef.current.selectionEnd = 5;
                }
            }
        };
        _this.onSubmitStart = function (value) {
            _this.props.setTimeRangeStart(value);
        };
        _this.onSubmitEnd = function (value) {
            _this.props.setTimeRangeEnd(value);
        };
        _this.onOutsideClickHandle = function () {
            if (_this.startRef.current) {
                _this.startRef.current.blur();
            }
            if (_this.endRef.current) {
                _this.endRef.current.blur();
            }
        };
        _this.startRef = React.createRef();
        _this.endRef = React.createRef();
        return _this;
    }
    TimeRange.prototype.render = function () {
        var _a = this.props, end = _a.end, inverted = _a.inverted, start = _a.start;
        return (React.createElement(OutsideClickHandler, { onOutsideClick: this.onOutsideClickHandle },
            React.createElement(Styled, { inverted: inverted },
                React.createElement(TimeInput, { getCursor: this.getStartCursor, forwardRef: this.startRef, inverted: inverted, onTimeValueChange: this.onSubmitStart, value: start, maxValue: end, isDisabled: this.props.disabled || false }),
                React.createElement("span", { className: "dash" }),
                React.createElement(TimeInput, { getCursor: this.getEndCursor, forwardRef: this.endRef, inverted: inverted, onTimeValueChange: this.onSubmitEnd, minValue: start, value: end, isDisabled: this.props.disabled || false }))));
    };
    return TimeRange;
}(React.Component));
export default TimeRange;
//# sourceMappingURL=index.js.map